import React, { useEffect, useRef } from 'react';
import { Box, Container, Typography } from '@mui/material';
import { motion, useScroll, useTransform } from 'framer-motion';
import { Swiper, SwiperSlide } from 'swiper/react';
import { EffectCoverflow, Autoplay } from 'swiper/modules';
import casestudy1 from '../assets/Images/techuzr-case-study.png';
import casestudy2 from '../assets/Images/klcreation-case-study.png';
import casestudy3 from '../assets/Images/geneq-case-study.png';
import casestudy4 from '../assets/Images/ambicaa-case-study.png';
import 'swiper/css';
import 'swiper/css/effect-coverflow';
import './CaseStudies.css';

const caseStudies = [
  {
    id: 1,
    title: "TechUzr",
    subtitle: "IT Consulting & Business Optimization",
    description: "TechUzr empowers businesses to streamline operations, optimize processes, and make data-driven decisions through expert IT consulting. Our tailored solutions in business process optimization, market research, and risk management have enabled clients to achieve measurable growth and operational excellence.",
    image: casestudy1, 
    color: "#FF4B91",
    stats: {
      users: "10K+",
      satisfaction: "97%",
      growth: "150%"
    }
  },
  {
    id: 2,
    title: "KLCreation",
    subtitle: "E-commerce Platform for Artisanal Candles",
    description: "KLCreation is a handcrafted candle brand dedicated to sustainability, artistry, and mindful living. Their e-commerce platform showcases a curated selection of premium, eco-friendly candles designed to bring warmth and elegance to everyday spaces.",
    image: casestudy2,
    color: "#47B5FF",
    stats: {
      users: "Growing user base",
      satisfaction: "High customer satisfaction",
      growth: "Rapid growth since launch"
    }
  },
  {
    id: 3,
    title: "GeneQ",
    subtitle: "Comprehensive Pathology & Genetic Lab Management System",
    description: "GeneQ is a digital platform for pathology labs, allowing patients to book tests and access reports online, while labs manage bookings and operations efficiently. GeneQ makes diagnostics simple and accessible for everyone.",
    image: casestudy3, 
    color: "#54B435",
    stats: {
      users: "2,300+",
      satisfaction: "97%",
      growth: "180%"
    }
  },
  {
    id: 4,
    title: "Ambicaa",
    subtitle: "Digital Fabric Marketplace",
    description: " Ambicaa is a digital marketplace for the fabric and textile industry, connecting manufacturers, distributors, and buyers. The platform streamlines product discovery, bulk ordering, and catalog management, while offering real-time order tracking and integrated support—empowering businesses to efficiently scale operations and deliver superior value to their customers.",
    image: casestudy4, 
    color: "#FFB100",
    stats: {
      users: "10K+",
      satisfaction: "97%",
      growth: "180%"
    }
  }
];

const CaseStudies = () => {
  const sectionRef = useRef(null);
  const { scrollYProgress } = useScroll({
    target: sectionRef,
    offset: ["start end", "end start"]
  });

  const opacity = useTransform(scrollYProgress, [0, 0.2, 0.8, 1], [0, 1, 1, 0]);
  const y = useTransform(scrollYProgress, [0, 0.2, 0.8, 1], [100, 0, 0, -100]);

  return (
    <Box
      ref={sectionRef}
      className="case-studies-section"
      sx={{
        py: { xs: 8, md: 12 },
        position: 'relative',
        overflow: 'hidden'
      }}
    >
      <Container maxWidth="lg">
        <motion.div
          style={{ opacity, y }}
          className="case-studies-content"
        >
          <Typography
            variant="h2"
            className="case-studies-section-title"
            sx={{
              textAlign: 'center',
              mb: 1
            }}
          >
            CASE <span className="highlight">STUDIES</span>
          </Typography>
          <Typography
            variant="h5"
            className="case-studies-section-subtitle"
            sx={{
              textAlign: 'center',
              mb: 6
            }}
          >
            Transforming Ideas into Digital Success Stories
          </Typography>

          <Box className="case-studies-slider">
            <Swiper
              effect={'coverflow'}
              grabCursor={true}
              centeredSlides={true}
              slidesPerView={'auto'}
              coverflowEffect={{
                rotate: 0,
                stretch: 0,
                depth: 100,
                modifier: 2.5,
                slideShadows: false,
              }}
              autoplay={{
                delay: 3000,
                disableOnInteraction: false,
              }}
              modules={[EffectCoverflow, Autoplay]}
              className="swiper-container"
            >
              {caseStudies.map((study) => (
                <SwiperSlide key={study.id}>
                  <motion.div
                    className="case-study-card"
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.6 }}
                    style={{
                      '--card-color': study.color
                    }}
                  >
                  <div className="case-study-image">
                    <img src={study.image} alt={study.title} />
                  </div>
                    <div className="case-study-content">
                      <Typography variant="overline" className="case-study-subtitle">
                        {study.subtitle}
                      </Typography>
                      <Typography variant="h4" className="case-study-title">
                        {study.title}
                      </Typography>
                      <Typography variant="body1" className="case-study-description">
                        {study.description}
                      </Typography>
                      {/* <div className="case-study-stats">
                        <div className="stat">
                          <Typography variant="h6">{study.stats.users}</Typography>
                          <Typography variant="body2">Active Users</Typography>
                        </div>
                        <div className="stat">
                          <Typography variant="h6">{study.stats.satisfaction}</Typography>
                          <Typography variant="body2">Satisfaction</Typography>
                        </div>
                        <div className="stat">
                          <Typography variant="h6">{study.stats.growth}</Typography>
                          <Typography variant="body2">YoY Growth</Typography>
                        </div>
                      </div> */}
                    </div>
                  </motion.div>
                </SwiperSlide>
              ))}
            </Swiper>
          </Box>
        </motion.div>
      </Container>
    </Box>
  );
};

export default CaseStudies; 